module.exports = __webpack_public_path__ + "static/media/twitter-footer.05949528.svg";